
import hdb from "../../lib/plugin/hdb.js"

hdb(window._hyperscript)

